var _g, _g2, _g3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCertificateRightGlow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 592,
    height: 601,
    viewBox: "0 0 592 601",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_2253_4654)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33.1343,
    height: 692.628,
    transform: "matrix(0.213716 0.976896 -0.979526 0.201318 889.292 208.19)",
    fill: "url(#paint0_linear_2253_4654)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_2253_4654)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.6561,
    height: 297.699,
    transform: "matrix(0.213716 0.976896 -0.979526 0.201318 852.934 219.99)",
    fill: "url(#paint1_linear_2253_4654)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "plus-lighter"
    },
    opacity: 0.6
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M496.272 339.361C496.636 339.332 496.905 339.015 496.873 338.653C496.84 338.291 496.519 338.021 496.154 338.05C495.79 338.079 495.521 338.396 495.554 338.758C495.587 339.121 495.908 339.391 496.272 339.361Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.734 342.794C499.007 342.772 499.209 342.534 499.184 342.262C499.16 341.991 498.919 341.788 498.646 341.81C498.373 341.832 498.171 342.07 498.196 342.341C498.22 342.613 498.461 342.815 498.734 342.794Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.993 335.046C509.266 335.024 509.467 334.787 509.443 334.515C509.419 334.244 509.177 334.041 508.904 334.063C508.631 334.085 508.43 334.322 508.454 334.594C508.479 334.866 508.72 335.068 508.993 335.046Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.924 336.623C481.197 336.602 481.399 336.364 481.375 336.092C481.35 335.821 481.109 335.618 480.836 335.64C480.563 335.662 480.362 335.9 480.386 336.171C480.41 336.443 480.651 336.645 480.924 336.623Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M465.319 345.792C465.683 345.763 465.952 345.445 465.919 345.083C465.887 344.721 465.565 344.451 465.201 344.48C464.837 344.509 464.568 344.826 464.601 345.188C464.633 345.551 464.955 345.821 465.319 345.792Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.412 339.08C458.594 339.065 458.728 338.907 458.712 338.726C458.695 338.545 458.535 338.41 458.353 338.425C458.171 338.439 458.037 338.598 458.053 338.779C458.069 338.96 458.23 339.094 458.412 339.08Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.429 352.222C496.611 352.208 496.745 352.049 496.729 351.868C496.713 351.687 496.552 351.552 496.37 351.567C496.188 351.581 496.054 351.74 496.07 351.921C496.087 352.102 496.247 352.237 496.429 352.222Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.264 346.491C568.446 346.477 568.58 346.319 568.564 346.138C568.548 345.957 568.387 345.822 568.205 345.836C568.023 345.851 567.889 346.009 567.905 346.19C567.922 346.371 568.082 346.506 568.264 346.491Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.964 352.783C386.146 352.769 386.281 352.611 386.264 352.43C386.248 352.249 386.087 352.114 385.906 352.128C385.724 352.143 385.589 352.301 385.606 352.482C385.622 352.663 385.783 352.798 385.964 352.783Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M379.435 335.479C379.617 335.464 379.751 335.306 379.735 335.125C379.719 334.944 379.558 334.809 379.376 334.824C379.194 334.838 379.06 334.997 379.076 335.177C379.093 335.358 379.253 335.493 379.435 335.479Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M365.945 344.148C366.127 344.134 366.261 343.975 366.245 343.794C366.229 343.613 366.068 343.478 365.886 343.493C365.704 343.508 365.57 343.666 365.586 343.847C365.602 344.028 365.763 344.163 365.945 344.148Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M378.585 362.947C378.766 362.933 378.901 362.774 378.884 362.593C378.868 362.412 378.708 362.278 378.526 362.292C378.344 362.307 378.209 362.465 378.226 362.646C378.242 362.827 378.403 362.962 378.585 362.947Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M455.827 343.577C456.009 343.562 456.143 343.404 456.127 343.223C456.11 343.042 455.95 342.907 455.768 342.921C455.586 342.936 455.452 343.094 455.468 343.275C455.484 343.456 455.645 343.591 455.827 343.577Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M496.835 364.076C497.016 364.062 497.151 363.903 497.134 363.722C497.118 363.541 496.958 363.406 496.776 363.421C496.594 363.435 496.459 363.594 496.476 363.775C496.492 363.956 496.653 364.091 496.835 364.076Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M559.803 355.749C559.985 355.735 560.119 355.576 560.103 355.395C560.087 355.214 559.926 355.079 559.744 355.094C559.563 355.108 559.428 355.267 559.444 355.448C559.461 355.629 559.621 355.764 559.803 355.749Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M400.388 343.38C400.57 343.366 400.704 343.207 400.688 343.027C400.672 342.846 400.511 342.711 400.329 342.725C400.147 342.74 400.013 342.898 400.029 343.079C400.046 343.26 400.206 343.395 400.388 343.38Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.585 319.633C474.766 319.618 474.901 319.46 474.884 319.279C474.868 319.098 474.708 318.963 474.526 318.978C474.344 318.992 474.209 319.151 474.226 319.332C474.242 319.512 474.403 319.647 474.585 319.633Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.27 314.929C525.452 314.914 525.586 314.756 525.57 314.575C525.554 314.394 525.393 314.259 525.211 314.274C525.029 314.288 524.895 314.447 524.911 314.628C524.928 314.809 525.088 314.944 525.27 314.929Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.887 351.576C455.069 351.561 455.203 351.403 455.187 351.222C455.171 351.041 455.01 350.906 454.828 350.92C454.646 350.935 454.512 351.093 454.528 351.274C454.545 351.455 454.705 351.59 454.887 351.576Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M431.821 353.417C432.003 353.402 432.137 353.244 432.121 353.063C432.105 352.882 431.944 352.747 431.762 352.762C431.58 352.776 431.446 352.935 431.462 353.116C431.478 353.297 431.639 353.432 431.821 353.417Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M402.979 335.252C403.161 335.237 403.295 335.079 403.279 334.898C403.263 334.717 403.102 334.582 402.92 334.596C402.738 334.611 402.604 334.769 402.62 334.95C402.637 335.131 402.797 335.266 402.979 335.252Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M481.225 327.027C481.407 327.012 481.541 326.854 481.525 326.673C481.509 326.492 481.348 326.357 481.166 326.371C480.984 326.386 480.85 326.544 480.866 326.725C480.883 326.906 481.043 327.041 481.225 327.027Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M461.05 357.358C461.232 357.343 461.367 357.185 461.35 357.004C461.334 356.823 461.173 356.688 460.991 356.702C460.81 356.717 460.675 356.875 460.692 357.056C460.708 357.237 460.868 357.372 461.05 357.358Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M421.473 363.815C421.655 363.801 421.789 363.642 421.773 363.462C421.757 363.281 421.596 363.146 421.414 363.16C421.232 363.175 421.098 363.333 421.114 363.514C421.131 363.695 421.291 363.83 421.473 363.815Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M409.945 342.619C410.127 342.604 410.261 342.446 410.245 342.265C410.229 342.084 410.068 341.949 409.886 341.964C409.704 341.978 409.57 342.137 409.586 342.318C409.602 342.499 409.763 342.633 409.945 342.619Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M560.551 316.074C560.733 316.06 560.867 315.901 560.851 315.72C560.835 315.539 560.674 315.405 560.492 315.419C560.311 315.434 560.176 315.592 560.193 315.773C560.209 315.954 560.369 316.089 560.551 316.074Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M524.077 349.686C524.441 349.657 524.71 349.34 524.677 348.978C524.645 348.615 524.323 348.345 523.959 348.374C523.595 348.403 523.326 348.721 523.359 349.083C523.391 349.445 523.713 349.715 524.077 349.686Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M542.637 338.303C543.002 338.274 543.27 337.956 543.238 337.594C543.205 337.232 542.884 336.962 542.52 336.991C542.156 337.02 541.887 337.337 541.919 337.699C541.952 338.062 542.273 338.332 542.637 338.303Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.443 326.845C541.716 326.823 541.918 326.585 541.893 326.314C541.869 326.042 541.628 325.84 541.355 325.861C541.082 325.883 540.88 326.121 540.905 326.393C540.929 326.664 541.17 326.867 541.443 326.845Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.799 363.075C522.072 363.053 522.274 362.815 522.25 362.544C522.225 362.272 521.984 362.07 521.711 362.092C521.438 362.113 521.237 362.351 521.261 362.623C521.285 362.894 521.526 363.097 521.799 363.075Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.43 372.392C417.703 372.37 417.905 372.132 417.88 371.861C417.856 371.589 417.615 371.387 417.342 371.408C417.069 371.43 416.867 371.668 416.892 371.939C416.916 372.211 417.157 372.413 417.43 372.392Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.931 368.351C373.204 368.329 373.406 368.092 373.381 367.82C373.357 367.548 373.116 367.346 372.843 367.368C372.57 367.39 372.368 367.627 372.393 367.899C372.417 368.17 372.658 368.373 372.931 368.351Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.151 355.687C366.424 355.665 366.626 355.428 366.601 355.156C366.577 354.884 366.336 354.682 366.063 354.704C365.79 354.726 365.588 354.963 365.613 355.235C365.637 355.506 365.878 355.709 366.151 355.687Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.216 334.662C526.489 334.641 526.691 334.403 526.667 334.131C526.642 333.86 526.401 333.657 526.128 333.679C525.855 333.701 525.654 333.939 525.678 334.21C525.702 334.482 525.943 334.684 526.216 334.662Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.06 363.492C471.333 363.47 471.535 363.232 471.51 362.961C471.486 362.689 471.245 362.487 470.972 362.509C470.699 362.53 470.497 362.768 470.522 363.04C470.546 363.311 470.787 363.514 471.06 363.492Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.364 370.961C555.637 370.939 555.838 370.702 555.814 370.43C555.79 370.159 555.549 369.956 555.276 369.978C555.003 370 554.801 370.237 554.825 370.509C554.85 370.781 555.091 370.983 555.364 370.961Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M568.657 325.002C569.021 324.973 569.29 324.655 569.257 324.293C569.225 323.931 568.903 323.661 568.539 323.69C568.175 323.719 567.906 324.036 567.939 324.398C567.971 324.761 568.293 325.031 568.657 325.002Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.565 301.731C566.929 301.702 567.198 301.385 567.166 301.023C567.133 300.661 566.811 300.391 566.447 300.42C566.083 300.449 565.814 300.766 565.847 301.128C565.88 301.49 566.201 301.76 566.565 301.731Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586.276 330.86C586.549 330.838 586.751 330.6 586.726 330.329C586.702 330.057 586.461 329.855 586.188 329.877C585.915 329.898 585.713 330.136 585.738 330.408C585.762 330.679 586.003 330.882 586.276 330.86Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M408.687 361.864C409.051 361.835 409.32 361.518 409.288 361.156C409.255 360.794 408.934 360.524 408.569 360.553C408.205 360.582 407.937 360.899 407.969 361.261C408.002 361.623 408.323 361.893 408.687 361.864Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M380.376 345.967C380.74 345.938 381.009 345.621 380.976 345.259C380.944 344.897 380.622 344.627 380.258 344.656C379.894 344.685 379.625 345.002 379.658 345.364C379.69 345.726 380.012 345.997 380.376 345.967Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M426.495 331.064C426.859 331.035 427.128 330.718 427.095 330.355C427.063 329.993 426.741 329.723 426.377 329.752C426.013 329.781 425.744 330.099 425.777 330.461C425.809 330.823 426.131 331.093 426.495 331.064Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M417.01 325.218C417.374 325.189 417.642 324.872 417.61 324.51C417.577 324.147 417.256 323.877 416.892 323.906C416.528 323.935 416.259 324.253 416.291 324.615C416.324 324.977 416.645 325.247 417.01 325.218Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M416.258 346.406C416.622 346.377 416.89 346.059 416.858 345.697C416.825 345.335 416.504 345.065 416.14 345.094C415.776 345.123 415.507 345.44 415.539 345.803C415.572 346.165 415.893 346.435 416.258 346.406Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.822 344.435C437.095 344.413 437.296 344.175 437.272 343.904C437.248 343.632 437.007 343.429 436.734 343.451C436.461 343.473 436.259 343.711 436.283 343.982C436.308 344.254 436.549 344.456 436.822 344.435Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.883 227.437C586.156 227.415 586.358 227.177 586.334 226.906C586.309 226.634 586.068 226.432 585.795 226.453C585.522 226.475 585.321 226.713 585.345 226.985C585.369 227.256 585.61 227.459 585.883 227.437Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M570.278 236.605C570.642 236.576 570.911 236.259 570.878 235.897C570.846 235.535 570.524 235.265 570.16 235.294C569.796 235.323 569.527 235.64 569.56 236.002C569.592 236.364 569.914 236.634 570.278 236.605Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.372 229.894C563.554 229.879 563.688 229.721 563.672 229.54C563.655 229.359 563.495 229.224 563.313 229.238C563.131 229.253 562.997 229.411 563.013 229.592C563.029 229.773 563.19 229.908 563.372 229.894Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.924 243.596C491.106 243.582 491.241 243.423 491.224 243.242C491.208 243.061 491.047 242.926 490.865 242.941C490.684 242.956 490.549 243.114 490.566 243.295C490.582 243.476 490.742 243.611 490.924 243.596Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M484.394 226.292C484.576 226.278 484.71 226.119 484.694 225.938C484.678 225.757 484.517 225.622 484.335 225.637C484.153 225.651 484.019 225.81 484.035 225.991C484.052 226.172 484.212 226.307 484.394 226.292Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M470.903 234.961C471.085 234.947 471.219 234.789 471.203 234.608C471.187 234.427 471.026 234.292 470.844 234.306C470.662 234.321 470.528 234.479 470.544 234.66C470.56 234.841 470.721 234.976 470.903 234.961Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M483.543 253.76C483.725 253.745 483.86 253.587 483.843 253.406C483.827 253.225 483.667 253.09 483.485 253.105C483.303 253.119 483.168 253.278 483.185 253.458C483.201 253.639 483.362 253.774 483.543 253.76Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M560.787 234.389C560.969 234.375 561.103 234.216 561.087 234.035C561.07 233.854 560.91 233.719 560.728 233.734C560.546 233.748 560.412 233.907 560.428 234.088C560.444 234.269 560.605 234.404 560.787 234.389Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M505.347 234.193C505.529 234.178 505.663 234.02 505.647 233.839C505.631 233.658 505.47 233.523 505.288 233.538C505.106 233.552 504.972 233.711 504.988 233.892C505.005 234.073 505.165 234.207 505.347 234.193Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.543 210.445C579.725 210.43 579.86 210.272 579.843 210.091C579.827 209.91 579.667 209.775 579.485 209.79C579.303 209.804 579.168 209.963 579.185 210.144C579.201 210.324 579.362 210.459 579.543 210.445Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.846 242.389C560.028 242.375 560.162 242.216 560.146 242.035C560.13 241.854 559.969 241.719 559.787 241.734C559.605 241.748 559.471 241.907 559.487 242.088C559.504 242.269 559.664 242.404 559.846 242.389Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M536.78 244.23C536.962 244.215 537.096 244.057 537.08 243.876C537.063 243.695 536.903 243.56 536.721 243.574C536.539 243.589 536.405 243.747 536.421 243.928C536.437 244.109 536.598 244.244 536.78 244.23Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M507.938 226.065C508.12 226.05 508.254 225.892 508.238 225.711C508.222 225.53 508.061 225.395 507.879 225.41C507.697 225.424 507.563 225.582 507.579 225.763C507.595 225.944 507.756 226.079 507.938 226.065Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M586.185 217.84C586.367 217.826 586.501 217.667 586.485 217.486C586.469 217.305 586.308 217.17 586.126 217.185C585.944 217.199 585.81 217.358 585.826 217.539C585.843 217.72 586.003 217.855 586.185 217.84Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M566.009 248.169C566.191 248.155 566.326 247.997 566.309 247.816C566.293 247.635 566.132 247.5 565.95 247.514C565.769 247.529 565.634 247.687 565.651 247.868C565.667 248.049 565.827 248.184 566.009 248.169Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M526.431 254.629C526.613 254.614 526.747 254.456 526.731 254.275C526.715 254.094 526.554 253.959 526.372 253.973C526.19 253.988 526.056 254.146 526.072 254.327C526.089 254.508 526.249 254.643 526.431 254.629Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M514.904 233.432C515.086 233.418 515.22 233.259 515.204 233.078C515.188 232.897 515.027 232.762 514.845 232.777C514.663 232.791 514.529 232.95 514.545 233.131C514.561 233.312 514.722 233.447 514.904 233.432Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.389 263.204C522.662 263.182 522.864 262.944 522.839 262.673C522.815 262.401 522.574 262.199 522.301 262.221C522.028 262.242 521.826 262.48 521.851 262.752C521.875 263.023 522.116 263.226 522.389 263.204Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.891 259.164C478.164 259.142 478.366 258.904 478.341 258.633C478.317 258.361 478.076 258.158 477.803 258.18C477.53 258.202 477.328 258.44 477.353 258.711C477.377 258.983 477.618 259.185 477.891 259.164Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.11 246.499C471.383 246.477 471.585 246.24 471.56 245.968C471.536 245.696 471.295 245.494 471.022 245.516C470.749 245.538 470.547 245.775 470.572 246.047C470.596 246.318 470.837 246.521 471.11 246.499Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.019 254.304C576.292 254.283 576.494 254.045 576.469 253.773C576.445 253.502 576.204 253.299 575.931 253.321C575.658 253.343 575.456 253.581 575.481 253.852C575.505 254.124 575.746 254.326 576.019 254.304Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M513.646 252.678C514.01 252.649 514.279 252.331 514.247 251.969C514.214 251.607 513.893 251.337 513.528 251.366C513.164 251.395 512.896 251.712 512.928 252.074C512.961 252.437 513.282 252.707 513.646 252.678Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M485.332 236.779C485.696 236.75 485.965 236.433 485.932 236.071C485.9 235.709 485.578 235.439 485.214 235.468C484.85 235.497 484.581 235.814 484.614 236.176C484.646 236.538 484.968 236.809 485.332 236.779Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M531.452 221.876C531.816 221.847 532.085 221.53 532.052 221.168C532.02 220.805 531.698 220.535 531.334 220.564C530.97 220.593 530.701 220.911 530.734 221.273C530.766 221.635 531.088 221.905 531.452 221.876Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M521.966 216.03C522.33 216.001 522.598 215.684 522.566 215.322C522.533 214.96 522.212 214.69 521.848 214.719C521.484 214.748 521.215 215.065 521.247 215.427C521.28 215.789 521.601 216.059 521.966 216.03Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M521.219 237.219C521.583 237.19 521.851 236.873 521.819 236.511C521.786 236.148 521.465 235.878 521.101 235.907C520.737 235.936 520.468 236.254 520.5 236.616C520.533 236.978 520.854 237.248 521.219 237.219Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.782 235.247C542.055 235.225 542.256 234.988 542.232 234.716C542.208 234.444 541.967 234.242 541.694 234.264C541.421 234.286 541.219 234.523 541.243 234.795C541.268 235.066 541.509 235.269 541.782 235.247Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_2253_4654",
    x: 34.1457,
    y: 31.4904,
    width: 1038.93,
    height: 525.207,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 88.35,
    result: "effect1_foregroundBlur_2253_4654"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_2253_4654",
    x: 441.329,
    y: 99.9902,
    width: 536.874,
    height: 324.019,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 60,
    result: "effect1_foregroundBlur_2253_4654"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2253_4654",
    x1: 16.5671,
    y1: 0,
    x2: 16.5671,
    y2: 692.628,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F59E0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2253_4654",
    x1: 12.328,
    y1: 0,
    x2: 12.328,
    y2: 297.699,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F59E0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCertificateRightGlow);
export default __webpack_public_path__ + "static/media/certificate-right-glow.34e4010e662984e0eb52d70b20780bfe.svg";
export { ForwardRef as ReactComponent };